
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
// own components
import AddressForm from 'components/addressForm';
import AddressDisplay from 'components/addressDisplay';
import Button from 'components/userzone/buttons/ButtonCustom';

const Addresses = ({
  address = 'billing_address',
  errorSave,
  successAddressSave,
  disableBtnSave,
  updateData,
  setUpdateData,
  handleSave
}) => {
  const { enabled_countries } = useCompanyStore();
  const { t } = useTranslation(['register', 'backoffice', 'header']);
  const [showAddress, setShowAddress] = useState({
    shipping_address: true,
    billing_address: true
  });
  const [showAddressForm, setShowAddressForm] = useState({
    shipping_address: false,
    billing_address: false
  });

  return (
    <Row id="addresses">
      <Col md={12}>
        <div className="addresses-container">
          {!showAddressForm[address] && (
            <>
              {updateData[address]?.address !== '' && showAddress[address] ? (
                <>
                  <AddressDisplay address={updateData[address]} />
                  <div className="d-flex w-100 justify-content-end gap-2 mt-5">
                    {errorSave !== '' && (
                      <div className="alert-danger align-items-center">
                        <span className="m-0">{errorSave}</span>
                      </div>
                    )}
                    {successAddressSave && (
                      <div className="alert-success align-items-center">
                        <span className="m-0">{t('directionchanges', { ns: 'register' })}</span>
                      </div>
                    )}
                    <Button
                      extraClass="m-2"
                      variant="primary"
                      onClick={() => {
                        setShowAddressForm({ ...showAddressForm, [address]: !showAddressForm[address] });
                        setShowAddress({ ...showAddress, [address]: false });
                      }}
                    >
                      {t('editar').toUpperCase()}
                    </Button>{' '}
                    <Button variant="secondary" extraClass="m-2">
                      {t('eliminar').toUpperCase()}
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <p>{t(address === 'billing_address' ? 'youhavenoaddress' : 'youdonothaveashippingaddress', { ns: 'register' })}</p>
                  <p>
                    <button 
                      type="button" 
                      className="btn btn-link p-0 border-0 bg-transparent"
                      onClick={() => setShowAddressForm({ ...showAddressForm, [address]: !showAddressForm[address] })}
                    >
                      {t('addaddress', { ns: 'header' })}
                    </button>
                  </p>
                </>
              )}
            </>
          )}

          {showAddressForm[address] && (
            <div className={`${showAddressForm[address] ? 'd-block' : 'd-none'}`}>
              <AddressForm
                data={updateData[address]}
                onChange={(newData) => setUpdateData({ [address]: newData })}
                onCancel={() => {
                  setShowAddressForm({ ...showAddressForm, [address]: false });
                  setShowAddress({ ...showAddress, [address]: true });
                }}
                onSave={() => {
                  handleSave();
                  setShowAddressForm({ ...showAddressForm, [address]: false });
                  setShowAddress({ ...showAddress, [address]: true });
                }}
                disableBtnSave={disableBtnSave}
                countries={enabled_countries}
                isShippingAddressDetails={false}
                isBillingAddressDetails={false}
              />
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Addresses;